import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from 'src/types/KeyCloak';
import { getCurrentDateMMDDYYYY, getCurrentTimeHHMMAMPM } from 'src/util/dt';

export interface IUserState {
  user?: IUser;
  currentDate: string;
  currentTime: string;
  dept: string;
}

const initialState: IUserState = {
  currentDate: getCurrentDateMMDDYYYY(),
  currentTime: getCurrentTimeHHMMAMPM(),
  dept: 'CRA'
};

export const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUserState: state => {
      state.user = undefined;
      state.currentDate = '';
      state.currentTime = '';
    },
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
    setToken: (state, action: PayloadAction<any>) => {
      if (state.user) {
        state.user.token = action.payload.token;
        state.user.siteToken = action.payload.siteToken;
        state.user.sponsorToken = action.payload.sponsorToken;
      }
    },
    setPreferences: (state, action: PayloadAction<any>) => {
      if (state.user) {
        state.user.preferences = action.payload;
      }
    },
    setPortalProps: (state, action: PayloadAction<any>) => {
      if (state.user) {
        state.user.portal_props = action.payload;
      }
    }
  }
});

export const { clearUserState, setUser, setToken, setPreferences, setPortalProps } = user.actions;
